import React from 'react';

const Icon = ({ size = '40', fill = '#00FF4F', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 40 40" fill="none" {...other}>
            <path
                d="M23.612 9.253h-8.198a.847.847 0 0 1-.848-.848V4.848c0-.468.38-.848.848-.848h8.195c.47 0 .85.38.85.848v3.554c0 .47-.38.85-.847.85Z"
                fill={fill}
            />

            <path
                d="M31.204 7.158h-4.727a.284.284 0 0 0-.284.284v2.426c0 .471-.38.848-.847.848h-11.39a.846.846 0 0 1-.847-.848V7.442a.284.284 0 0 0-.283-.284H8.095A2.095 2.095 0 0 0 6 9.253V34.84c0 1.157.938 2.094 2.095 2.094h23.11a2.095 2.095 0 0 0 2.094-2.094V9.253a2.095 2.095 0 0 0-2.095-2.095ZM16.628 30.877c0 .57-.46 1.031-1.03 1.031H9.57a1.03 1.03 0 1 1 0-2.062h6.026c.57 0 1.031.46 1.031 1.031Zm0-5.082c0 .57-.46 1.031-1.03 1.031H9.57a1.03 1.03 0 1 1 0-2.062h6.026c.57 0 1.031.464 1.031 1.03Zm3.03-5.08a1.03 1.03 0 0 1-1.032 1.032H9.571a1.03 1.03 0 1 1 0-2.062h9.055c.57 0 1.032.46 1.032 1.03Z"
                fill={fill}
            />
        </svg>
    );
};
export default React.memo(Icon);
